import { render, staticRenderFns } from "./InfoDetailsNota.vue?vue&type=template&id=5b1e0e40&scoped=true"
var script = {}
import style0 from "./InfoDetailsNota.vue?vue&type=style&index=0&id=5b1e0e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e0e40",
  null
  
)

export default component.exports